var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE4Canteen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63 19.6V41h-4v18.75a2 2 0 01-2.65 1.9 2 2 0 01-1.35-2V19.76a4 4 0 118-.16zM47 30h-4V16h-4v14h-4V16h-4v14a10 10 0 008 9.8v20a2 2 0 004 0v-20a10 10 0 008-9.8V16h-4v14zM13 17.42v4.36A18.84 18.84 0 0113 56v4.37a22.9 22.9 0 000-43v.05z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/E4_Canteen.e8c43711.svg";
export { SvgE4Canteen as ReactComponent };